<template>
    <div class="home-banner margin-bottom-xl" v-if="currentPage && currentPage.acf">
        <VideoPopup v-if="currentPage.acf.popup_video && videoBannerCanShow" @close="showHidePopup" :isOpen="popupOpen" :videoUrl="currentPage.acf.popup_video" />
        <div class="vidoter">
            <div 
                class="vimeo-bg wp-image-vue" :class="{'player-ready' : playerIsReady }" 
                v-if="vimeoBgId"
                v-observe-visibility="{
                    callback: vimeoVisibility,
                    throttle: 150,
                }">
                <vueVimeoPlayer 
                    v-if="videoBannerCanShow"
                    ref="player" 
                    class="bg-video"
                    :video-id="vimeoBgId" 
                    @ready="onReadyVimeo" 
                    @loaded="loadedVimeo"
                    :options="bgVideoOpt" 
                    :autoplay="true" 
                    :background="true"
                    :loop="true" />
            </div>
            <WpImage
                v-if="currentPage.acf.placeholder_image"
                :image="currentPage.acf.placeholder_image"
                size="large"
                cover
                background
            />
        </div>
        <div class="informator">
            <div class="inner container padding-bottom-xl padding-top-lg">
                <Button 
                    v-if="currentPage.acf.popup_video && videoBannerCanShow" 
                    @click.native="showHidePopup" 
                    :outlined="false" 
                    :hasIcon="true" 
                    type="white" 
                    class="play-btn-banner text-uppercase font--600">
                    Se filmen<span v-html="displayPlayButton()"/>
                </Button>
                <h1 class="titler dm dm--75 font--400" v-html="currentPage.acf.title"></h1>
                <div class="overlay"/>
            </div>
        </div>
    </div>
</template>

<script>
import WpImage from '@/components/elements/WpImage';
import ColorLink from '@/components/elements/ColorLink'
import { play } from '@/components/../icons';
import Button from '@/components/elements/Button'
import VideoPopup from '@/components/elements/VideoPopup'
import { vueVimeoPlayer } from 'vue-vimeo-player'
import { vimeoID } from '@/helpers'

import { mapGetters } from 'vuex';


//acf.background_video
//acf.popup_video
export default {
    name: 'home-banner',
    data(){
        return {
            popupOpen: false,
            playerIsReady: false,
            videoBannerCanShow: false,
            playerIsPlaying: false,
            bgVideoOpt: {
                loop: true,
                autoplay: 1,
                background: 1,
                controls: false,
                muted: true
            }
        }
    },
    beforeDestroy() {
        const VM = this;
        if(this.extendedCookies){
            window.removeEventListener('CookieInformationConsentGiven', VM.cookieSolution, false)
        }
    },
    mounted() {
        const VM = this;
        if(this.extendedCookies ){
            window.addEventListener('CookieInformationConsentGiven', VM.cookieSolution, false)
        }

        if(!this.extendedCookies){
            VM.videoBannerCanShow = true
        }
    },
    methods:{
        cookieSolution(){
            const VM = this;
            if (CookieInformation && CookieInformation.getConsentGivenFor('cookie_cat_marketing')) { 
                VM.videoBannerCanShow = true
            }else{
                VM.videoBannerCanShow = false
            }
        },
        displayPlayButton(){
            return play();
        },
        showHidePopup(){
            this.popupOpen = !this.popupOpen;
        },
        loadedVimeo(){
            this.playerIsPlaying = true
            this.playerIsReady = true
        },
        onReadyVimeo(){
//            this.playerIsReady = true
        },
        vimeoVisibility(visibility){
            if(this.playerIsReady){
                if(this.playerIsPlaying && !visibility){
                this.$refs.player.pause()
                this.playerIsPlaying = false
                }
                if(!this.playerIsPlaying && visibility){
                this.playerIsPlaying = true
                this.$refs.player.play()
                }
            }
        },
    },
    computed: {
        vimeoBgId(){
            if(this.currentPage.acf.background_video){
                return vimeoID(this.currentPage.acf.background_video)
            }else{
                return null
            }
        },
        ...mapGetters([
        	'getOptions',
            'currentPage',
            'isFrontPage'
        ]),
        extendedCookies(){
            return this.getOptions.use_cookiesinformationcom
        }
        
    },
    components:{
        WpImage,
        ColorLink,
        Button,
        VideoPopup,
        vueVimeoPlayer
    }
    
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
@import "@/assets/extends.scss";
.home-banner{
    position: relative;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    .vidoter{
        position: relative;
    }
    .vimeo-bg{
        position: absolute;
        z-index: 5;
        opacity: 0;
        transition: 0.1s opacity ease-in-out;
        will-change: opacity;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        &.player-ready{
            opacity: 1;
        }
        .vimeo-container{
        pointer-events: none;
        --video--width: 16;
        --video--height: 9;
        position: relative;
        padding-bottom: calc(var(--video--height) / var(--video--width) * 100%); /* 41.66666667% */
        overflow: hidden;
        max-width: 100%;
        background: black;
        }
        iframe{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        }
    }
    .informator{
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        z-index: 10;
        .titler{
            margin-top: 25px;
            margin-bottom: 0;
            color: #fff;
            z-index: 2;
            position: relative;
        }
        @include mquery($phone){
            position: relative;
            background-color: $dark;
            .titler{
                margin-top: 15px;
                font-size: 32px;
            }

        }
    }
    .play-btn-banner{
        position: relative;
        z-index: 3;
        margin-left: 0;
    }
    .overlay{
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        background-image: linear-gradient(180deg, rgba(20,61,84,0.00) 0%, #143D54 100%);
        z-index: 1;
    }
    
}
</style>
